import { ALLOW_PATHS } from "../../constants/Security";

export function allowPaths(paths) {
    return {
        type: ALLOW_PATHS,
        payload: {paths}
    };
};